module.exports = __webpack_public_path__ + "img/scheme-default.fdacc816.jpg";